import React, { useState } from "react"
import { MapPin, Map } from "lucide-react"
import { GPSModal } from "./GPSModal"
import { inputCls } from "./Field"

interface GPSCaptureProps {
  latitude: string
  longitude: string
  onLatChange: (v: string) => void
  onLngChange: (v: string) => void
}

export const GPSCapture: React.FC<GPSCaptureProps> = ({
  latitude, longitude, onLatChange, onLngChange,
}) => {
  const [modalOpen, setModalOpen] = useState(false)

  const handleConfirm = (lat: string, lng: string) => {
    onLatChange(lat)
    onLngChange(lng)
  }

  return (
    <>
      <div className="space-y-3">

        {/* Two action buttons */}
        <div className="grid grid-cols-2 gap-2">
          <button
            type="button"
            onClick={() => setModalOpen(true)}
            className="flex items-center justify-center gap-2 px-3 py-2.5 bg-white/5 hover:bg-white/10 border border-neutral-700 hover:border-emerald-500/50 rounded-lg text-xs font-medium text-neutral-300 transition-all"
          >
            <MapPin className="w-3.5 h-3.5 text-emerald-400" />
            Use GPS
          </button>

          <button
            type="button"
            onClick={() => setModalOpen(true)}
            className="flex items-center justify-center gap-2 px-3 py-2.5 bg-white/5 hover:bg-white/10 border border-neutral-700 hover:border-emerald-500/50 rounded-lg text-xs font-medium text-neutral-300 transition-all"
          >
            <Map className="w-3.5 h-3.5 text-emerald-400" />
            Pick on Map
          </button>
        </div>

        {/* Confirmed location display */}
        {latitude && (
          <div
            className="flex items-center gap-2 bg-emerald-500/10 border border-emerald-500/20 rounded-lg px-3 py-2 cursor-pointer hover:bg-emerald-500/15 transition-colors"
            onClick={() => setModalOpen(true)}
          >
            <MapPin className="w-3 h-3 text-emerald-400 flex-shrink-0" />
            <span className="text-emerald-400 text-[11px] font-mono flex-1">
              {latitude}, {longitude}
            </span>
            <span className="text-emerald-600 text-[10px]">Edit</span>
          </div>
        )}

        {/* Manual fallback inputs */}
        <div className="grid grid-cols-2 gap-3">
          <input
            className={inputCls}
            placeholder="Latitude"
            value={latitude}
            onChange={e => onLatChange(e.target.value)}
          />
          <input
            className={inputCls}
            placeholder="Longitude"
            value={longitude}
            onChange={e => onLngChange(e.target.value)}
          />
        </div>
      </div>

      <GPSModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        onConfirm={handleConfirm}
        initialLat={latitude}
        initialLng={longitude}
      />
    </>
  )
}